import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as group from '../group'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    constraints: {
      max: { value: 1 },
      min: { value: 0 },
    },
    context: core.dms.models.Attribute.Id.Context.from({
      context: group.RESOURCE.payload.dimension.partialId,
      partialId: group.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'IDC Rate %',
    isOptional: true,
    name: 'IDC Rate',
    partialId: PartialId.Standard.create('idc_rate'),
    type: core.common.value.types.Intrinsic.Percent,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
